/** Inventory helpers — API field is `stock_quantity` (legacy `stock` fallback). */

export const LOW_STOCK_THRESHOLD = 8;

export function getProductStockQuantity(product) {
  if (!product) return 0;

  if (product.stock_quantity !== undefined && product.stock_quantity !== null) {
    const n = Number(product.stock_quantity);
    return Number.isFinite(n) ? Math.max(0, Math.floor(n)) : 0;
  }

  if (product.stock !== undefined && product.stock !== null) {
    const n = Number(product.stock);
    return Number.isFinite(n) ? Math.max(0, Math.floor(n)) : 0;
  }

  return 0;
}

export function isProductInStock(product) {
  return getProductStockQuantity(product) > 0;
}

export function isProductLowStock(product, threshold = LOW_STOCK_THRESHOLD) {
  const qty = getProductStockQuantity(product);
  return qty > 0 && qty <= threshold;
}

export function getProductAvailabilityLabel(product) {
  const qty = getProductStockQuantity(product);
  if (qty <= 0) return "Out of stock";
  return `In stock (${qty} available)`;
}

export function clampQuantityToStock(quantity, product) {
  const stock = getProductStockQuantity(product);
  if (stock <= 0) return 1;
  return Math.min(Math.max(1, quantity), stock);
}
